import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ReportEmptyState: FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{ padding: "40px", textAlign: "center", width: "100%" }}
    >
      <Typography
        sx={{
          color: "#323947",
          fontWeight: 500,
          fontSize: "16px"
        }}
      >
        {t("common.noDataAvailableYet")}
      </Typography>
    </Box>
  );
};

export default ReportEmptyState;
